import { useId, useRef } from 'react'
import { gsap, prefersReduced } from '../lib/gsap.js'
import useOutsideClose from './hooks/useOutsideClose.js'
import useFocusTrap from './hooks/useFocusTrap.js'
import Button from './Button.jsx'

export default function SlideOver({ onClose, title, chip, footer, width = 480, className = '', children }) {
  const panelRef = useRef(null)
  const backdropRef = useRef(null)
  const closingRef = useRef(false)
  const titleId = useId()

  const requestClose = () => {
    if (closingRef.current) return
    closingRef.current = true
    if (prefersReduced() || !panelRef.current) { onClose(); return }
    const phone = typeof window !== 'undefined' && window.matchMedia('(max-width: 640px)').matches
    const out = phone ? { yPercent: 100 } : { xPercent: 100 }
    const tl = gsap.timeline({ onComplete: onClose })
    tl.to(panelRef.current, { ...out, duration: 0.18, ease: 'power1.in' }, 0)
    if (backdropRef.current) tl.to(backdropRef.current, { opacity: 0, duration: 0.18 }, 0)
  }

  useOutsideClose(panelRef, true, requestClose)
  useFocusTrap(panelRef, true)

  return (
    <>
      <div ref={backdropRef} className="cn-slideover-backdrop" />
      <div
        ref={panelRef}
        className={`cn-slideover ${className}`.trim()}
        style={{ '--cn-slideover-w': typeof width === 'number' ? `${width}px` : width }}
        role="dialog" aria-modal="true" aria-labelledby={title ? titleId : undefined}
      >
        <div className="cn-slideover-head">
          {chip}
          {title && <h2 id={titleId} className="cn-slideover-title">{title}</h2>}
          {!title && <span style={{ flex: 1 }} />}
          <Button variant="subtle" size="sm" onClick={requestClose} aria-label="Close">✕</Button>
        </div>
        <div className="cn-slideover-body">{children}</div>
        {footer && <div className="cn-slideover-foot">{footer}</div>}
      </div>
    </>
  )
}
